import { createStore } from "vuex"
import customer from "./customer"
import category from "./category"
import stock from "./stock"
import pot from "./pot"
import payments from "./payments"
import user from "./user"
import product from "./product"
import seller from "./seller"
import loading from "./loading"
import systemDialog from "./systemDialog"
import systemDialogOptions from "./systemDialogOptions"
import order from "./order"
import transfer from "./transfer"
import relats from "./relats"

export default createStore({
  modules: {
    customer,  
    category, 
    stock,
    pot,
    payments,
    user,
    product,
    seller,
    loading,
    systemDialog,
    systemDialogOptions,
    order,
    transfer,
    relats
  },
})
